import Validation from "utils/validation.utils";

export const initialState = (state = {}) => {
  const {
    mobileNumber = {
      value: "",
      disabled: false,
    },
    points = {
      value: "",
      disabled: false,
    },
    firstName = {
      value: "",
      disabled: false,
    },
    lastName = {
      value: "",
      disabled: false,
    },
    isPointsExpiring = {
      value: false,
      disabled: false,
    },
    expiringPoints = {
      value: "",
      disabled: false,
    },
    expiryDate = {
      value: "",
      disabled: false,
    },
  } = state;

  return {
    mobileNumber: {
      name: "mobileNumber",
      placeholder: "9xxxxxxxxx",
      maxLength: 10,
      required: true,
      validations: [
        Validation.required({ noMessage: true }),
        Validation.numeric(),
        Validation.mobileNumberv2(),
      ],
      ...mobileNumber,
    },
    points: {
      name: "points",
      required: false,
      ...points,
    },
    firstName: {
      name: "firstName",
      required: false,
      ...firstName,
    },
    lastName: {
      name: "lastName",
      required: false,
      ...lastName,
    },
    isPointsExpiring: {
      name: "isPointsExpiring",
      required: false,
      ...isPointsExpiring,
    },
    expiringPoints: {
      name: "expiringPoints",
      required: false,
      ...expiringPoints,
    },
    expiryDate: {
      name: "expiryDate",
      required: false,
      ...expiryDate,
    },
  };
};
